import React from 'react';
import { useIntl } from 'react-intl';
import { states } from '@/constants/lifecycle';
import RequestWorkspaceMessage from './RequestWorkspaceMessage';
import RequestStepInfoContent from '../../components/RequestStepInfoContent';
import Selectors from '../hooks/selectors';
import Fetch from '../hooks/fetch';

const RequestWorkspaceInfo = ({ category, code }) => {
  const intl = useIntl();
  const state = Selectors.useRequestWorkspaceInfo({ category, code });
  Fetch.useFetchWorkspaceFormForRequest({ category: 'open', code, intl }, state.readStatus);

  return (
    <RequestStepInfoContent
      category={category}
      code={code}
      fields={state.fields}
      name={state.name}
      readErrors={state.readErrors}
      readStatus={state.readStatus}
      request={state.request}
      section="workspace"
      sourceCode={state.sourceCode}
      sourceType={state.sourceType}
      saveErrors={state.saveErrors}
      saveStatus={state.saveStatus}
    >
      {state.readStatus === states.SUCCESS && (<RequestWorkspaceMessage />)}
    </RequestStepInfoContent>
  );
};

export default RequestWorkspaceInfo;
